module.exports = __webpack_public_path__ + "static/media/gb-sct.27d33587.svg";